import { Typography } from "@mui/material";
import {
  last14Days,
  last30Days,
  last3rdMonth,
  lastMonthEnd,
  lastMonthStart,
  todayEnd,
} from "constants/dates";
import { formattedDateRange } from "helpers/helpers";
import { useTranslation } from "react-i18next";
import StyledCalendarToggleButton from "./StyledCalendarToggleButton";

const SelectionInvoices = ({
  setLast14Days,
  setLast30Days,
  setLastMonth,
  setLast3Months,
}) => {
  const { t } = useTranslation();

  return (
    <>
      <StyledCalendarToggleButton
        value="last 14 days"
        aria-label="last 14 days"
        onClick={setLast14Days}
      >
        <Typography>{t("invoice.datePicker.lastFourteenDays")}</Typography>
        <Typography>{formattedDateRange(last14Days, todayEnd)}</Typography>
      </StyledCalendarToggleButton>
      <StyledCalendarToggleButton
        value="last 30 days"
        aria-label="last 30 days"
        onClick={setLast30Days}
      >
        <Typography>{t("invoice.datePicker.lastThirtyDays")}</Typography>
        <Typography>{formattedDateRange(last30Days, todayEnd)}</Typography>
      </StyledCalendarToggleButton>
      <StyledCalendarToggleButton
        value="last month"
        aria-label="last month"
        onClick={setLastMonth}
      >
        <Typography>{t("invoice.datePicker.lastMonth")}</Typography>
        <Typography>
          {formattedDateRange(lastMonthStart, lastMonthEnd)}
        </Typography>
      </StyledCalendarToggleButton>
      <StyledCalendarToggleButton
        value="last 3 months"
        aria-label="last 3 months"
        onClick={setLast3Months}
      >
        <Typography>{t("invoice.datePicker.lastQuarter")}</Typography>
        <Typography>
          {formattedDateRange(last3rdMonth, lastMonthEnd)}
        </Typography>
      </StyledCalendarToggleButton>
    </>
  );
};

export default SelectionInvoices;
